import * as theme from "./theme.css";

export function FieldDrawerSeparator() {
    return <div className={theme.drawerSeparator} />;
}
